import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sprout, Heart, Gift, EyeOff, Eye, Calendar, Radio, HeartHandshake, Smartphone } from "lucide-react";
import api from "@/lib/api";
import { useFeature } from "@/contexts/FeaturesContext";

/* ── Portofelul de Semințe (17.12) ── */


/* ── Biblioteca mea: lecțiile care m-au atins (17.6) ── */
export function MyLibrary() {
  const enabled = useFeature("hearted_lessons");
  const [items, setItems] = useState([]);
  useEffect(() => { if (enabled) api.get("/me/hearted").then((r) => setItems(r.data.items || [])).catch(() => {}); }, [enabled]);
  if (!enabled || items.length === 0) return null;
  return (
    <div className="card-premium p-6" data-testid="my-library">
      <h3 className="font-serif text-lg mb-3 inline-flex items-center gap-2"><Heart size={16} style={{ color: "var(--ct-gold)" }} /> Biblioteca mea</h3>
      <p className="text-[11px] mb-3" style={{ color: "var(--ct-text-dim)" }}>Lecțiile care te-au atins. Revino la ele în zilele grele.</p>
      <div className="space-y-1.5">
        {items.map((h) => (
          <Link key={h.id} to={h.course_slug ? `/cursuri/${h.course_slug}/invata` : "/cont"} className="block text-sm py-1.5 px-2 rounded-lg hover:bg-[var(--ct-bg-soft)] transition-colors" style={{ color: "var(--ct-text)" }}>
            🤍 {h.lesson_title}
          </Link>
        ))}
      </div>
    </div>
  );
}
